module.exports = __webpack_public_path__ + "static/assets/55b56d9f7b5eb7267f4ac19441146e85.gif";